<div class="appliances-container">
        Show Appliances tab
</div>

